module.exports = __webpack_public_path__ + "static/media/circle-sabio.42c37329.svg";